import {
  Tooltip,
  Button,
  Text,
  DropdownMenu,
  IconButton,
  EllipsisVerticalIcon,
  TrashIcon,
  PencilIcon,
  Flex,
  Card,
} from '@buffer-mono/popcorn'

import type { HashtagGroup } from '~publish/legacy/hashtag-group-manager/types'

import styles from './HashtagGroupItem.module.css'

import type { JSX } from 'react'

interface HashtagGroupItemProps {
  group: HashtagGroup
  hashtagsCount: number
  onInsert: () => void
  onEdit: (group: HashtagGroup) => void
  onDelete: (group: HashtagGroup) => void
}

export const HashtagGroupItem = ({
  group,
  hashtagsCount,
  onInsert,
  onEdit,
  onDelete,
}: HashtagGroupItemProps): JSX.Element => {
  return (
    <Card className={styles.item}>
      <Flex direction="column" gap="3xs" className={styles.content}>
        <Flex align="center" gap="xs" fullWidth>
          <Tooltip content={group.name}>
            <Text weight="medium" truncate>
              {group.name}
            </Text>
          </Tooltip>
          <Text color="subtle">•</Text>
          <Text color="subtle">{hashtagsCount}</Text>
        </Flex>
        <Tooltip content={group.text}>
          <Text color="subtle" className={styles.text} truncate>
            {group.text}
          </Text>
        </Tooltip>
      </Flex>
      <Flex gap="2xs" align="center" className={styles.actions}>
        <Button onClick={onInsert}>Insert</Button>
        <DropdownMenu>
          <DropdownMenu.Trigger>
            <IconButton label="More options" variant="tertiary">
              <EllipsisVerticalIcon />
            </IconButton>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content align="end">
            <DropdownMenu.Item onClick={() => onEdit(group)}>
              <PencilIcon color="subtle" />
              Edit Group
            </DropdownMenu.Item>
            <DropdownMenu.Item
              onClick={() => onDelete(group)}
              variant="critical"
            >
              <TrashIcon color="critical" />
              Delete Group
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu>
      </Flex>
    </Card>
  )
}
